<div class="header">
  <h2>{{this.input.timeBlock.type}}: {{this.input.timeBlock.parentTask.name}}</h2>
  <span class="flex-spacer"></span>
  <button type="button"
          aria-label="Close"
          (click)="this.close()"
          disableRipple
          mat-flat-button>
    <mat-icon aria-hidden="false">close</mat-icon>
  </button>
</div>
<div class="sub-header">
  <div class="timestamps">
    <span>{{this.formattedStartTime}}</span>
    <ng-container *ngIf="!this.input.timeBlock.isIndefinite">
      <div class="arrow">
        <span class="flex-spacer"></span>
        <mat-icon>arrow_right</mat-icon>
      </div>
      <span>{{this.formattedEndTime}}</span>
    </ng-container>
  </div>
  <div class="duration" *ngIf="!this.input.timeBlock.isIndefinite">
    <span class="flex-spacer"></span>
    <span>{{this.formattedDuration}}</span>
    <span class="flex-spacer"></span>
  </div>
</div>

<mat-nav-list>
  <a mat-list-item (click)="this.editOperatorNote()">
    <mat-icon mat-list-icon>comment</mat-icon>
    <span mat-line>{{this.hasNote? "Edit" : "Add"}} Note</span>
  </a>

  <a mat-list-item *ngIf="this.hasNote" (click)="this.removeOperatorNote()">
    <mat-icon mat-list-icon>backspace</mat-icon>
    <span mat-line>Remove Note</span>
  </a>

  <a mat-list-item *ngIf="this.isEditable" (click)="this.editTimeBlock()">
    <mat-icon mat-list-icon class="rot90">height</mat-icon>
    <span mat-line>Edit Times</span>
  </a>
</mat-nav-list>